<template>
	<div id="map">

	</div>
</template>
<script>
	export default{
		name:"GMap",
		props:{
			center: {
      			type: Object,
      			default: () => ({ lat: 23.492770, lng: 120.379690 })
    		},
    		zoom: {
			    type: Number,
			    default: 10
    		},
    		streetViewControl: {
    			type: Boolean,
    			default: true
    		},
		    mapTypeControl: {
		    	type: Boolean,
		    	default: false
		    },
		    fullscreenControl: {
		    	type: Boolean,
		    	default: true
		    },
		    zoomControl: {
		    	type: Boolean,
		    	default: true
		    }
		},
		data(){
			return{
				map:null,
				infowindow: null,
      			images:[
      				require('@/assets/images/bg_info.png'),
      				require('@/assets/images/bg_map_1.png'),
      				require('@/assets/images/bg_map_2.png'),
      				require('@/assets/images/bg_map_3.png'),
      			],
      			index:0
			}
		},
		mounted(){
			this.initMap()
			this.setMarker()
			// this.timer()
		},
		computed:{
			orignDestination(){
				return this.center
			}
		},
		methods:{
			initMap(){
					this.map = new google.maps.Map(document.getElementById('map'),{
						center: this.center,
	        			zoom: this.zoom,
	        			maxZoom: 20,
						minZoom: 3,
						controlSize:20,
	        			streetViewControl: this.streetViewControl,
	        			mapTypeControl: this.mapTypeControl,
	        			fullscreenControl: this.fullscreenControl,
	        			zoomControl: this.zoomControl
					})
    			},
			setMarker(){
					
					const marker = new google.maps.Marker({
						position:{lat:this.center.lat,lng:this.center.lng},
						map:this.map,
						icon:"http://maps.google.com/mapfiles/kml/paddle/red-stars.png"
					})
					const infowindows = new google.maps.InfoWindow({
    						content:`
    						<div class="infoWindow" style="color:black;">
    							<h5>Soonport</h5>
    							<p>No.87, Lane 105, Section 2, Beigang Road, Taibao City, Chiayi County, Taiwan 612</p>
    						</div>
    						`
    					})
					infowindows.open(this.map, marker);
					marker.addListener('click',()=>{
    						if(infowindows.anchor){
            					infowindows.close();
        					}else{
            					infowindows.open(this.map, marker);
        					}
    					})
			},
			timer(){
				let time = 0,indexx
				setInterval(()=>{
					time++
					indexx = time%3
					console.log(indexx)
					this.index = indexx
				},2000)
			}
		}
	}
	
</script>